/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uploading_DialogueInputs */



/**
* | output |
* | --- |
* | "Uploading dialogue data..." |
*
* @param {Uploading_DialogueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const uploading_dialogue = /** @type {((inputs?: Uploading_DialogueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uploading_DialogueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement des données de dialogue...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dialogdaten werden hochgeladen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento dei dati del dialogo in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка данных диалога...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando datos de diálogo...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在上传对话数据……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("対話データをアップロードしています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संवाद डेटा अपलोड किया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando dados de diálogo...")
	return /** @type {LocalizedString} */ ("Uploading dialogue data...")
});